module.exports = __webpack_public_path__ + "static/media/18ECA35.d27d82cb.jpg";